import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "lc_ttop"
};
const _hoisted_2 = {
  style: {
    "padding-bottom": "50px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LcButtons = _resolveComponent("LcButtons");
  const _component_lcBaseInfo = _resolveComponent("lcBaseInfo");
  const _component_Lcbzljtable = _resolveComponent("Lcbzljtable");
  const _component_lcwjsc = _resolveComponent("lcwjsc");
  const _component_lctinymce = _resolveComponent("lctinymce");
  const _component_LcWriteLinks = _resolveComponent("LcWriteLinks");
  const _component_el_main = _resolveComponent("el-main");
  return _openBlock(), _createBlock(_component_el_main, {
    class: "bg_white wrap_box lc_rw"
  }, {
    default: _withCtx(() => [_createVNode(_component_LcButtons, {
      ref: "lcButtons",
      type: 2,
      onBtsEmit: _cache[0] || (_cache[0] = $event => _ctx.btsEmit($event)),
      planStratTime: _ctx.data.baseInfo.plan_start_time_text,
      ids: _ctx.ids,
      projectName: _ctx.data.baseInfo.project_name,
      reviewerUserId: _ctx.data.baseInfo.reviewer_user_id,
      userId: _ctx.data.baseInfo.leader_user_id,
      msg: _ctx.data.baseInfo.msg,
      onGetPageInfo: _ctx.getPageInfo,
      deppgetPageInfo: _ctx.getPageInfo
    }, null, 8, ["planStratTime", "ids", "projectName", "reviewerUserId", "userId", "msg", "onGetPageInfo", "deppgetPageInfo"]), _createElementVNode("div", _hoisted_1, [_createVNode(_component_lcBaseInfo, {
      ref: "addBaseInfo",
      type: "taskInfo"
    }, null, 512)]), _cache[11] || (_cache[11] = _createElementVNode("div", {
      class: "lc_title lc_ttop lc_add_ggdyb"
    }, "标准零件选择", -1)), _createVNode(_component_Lcbzljtable, {
      bzljxzTableData: _ctx.data.bzljxzTableData,
      "onUpdate:bzljxzTableData": _cache[1] || (_cache[1] = $event => _ctx.data.bzljxzTableData = $event),
      pagetype: 'gyskj'
    }, null, 8, ["bzljxzTableData"]), _cache[12] || (_cache[12] = _createElementVNode("div", {
      class: "lc_title lc_ttop lc_add_ggdyb"
    }, "ID效果图", -1)), _createVNode(_component_lcwjsc, {
      loading: _ctx.IDxgtpptdata.loading,
      "onUpdate:loading": _cache[2] || (_cache[2] = $event => _ctx.IDxgtpptdata.loading = $event),
      tableHeigth: _ctx.IDxgtpptdata.tableHeigth,
      "onUpdate:tableHeigth": _cache[3] || (_cache[3] = $event => _ctx.IDxgtpptdata.tableHeigth = $event),
      listHeader: _ctx.IDxgtpptdata.listHeader,
      "onUpdate:listHeader": _cache[4] || (_cache[4] = $event => _ctx.IDxgtpptdata.listHeader = $event),
      defaultRow: _ctx.IDxgtpptdata.defaultRow,
      "onUpdate:defaultRow": _cache[5] || (_cache[5] = $event => _ctx.IDxgtpptdata.defaultRow = $event),
      tableHeader: _ctx.IDxgtpptdata.tableHeader,
      "onUpdate:tableHeader": _cache[6] || (_cache[6] = $event => _ctx.IDxgtpptdata.tableHeader = $event),
      notShowCol: _ctx.IDxgtpptdata.notShowCol,
      "onUpdate:notShowCol": _cache[7] || (_cache[7] = $event => _ctx.IDxgtpptdata.notShowCol = $event),
      staticList: _ctx.IDxgtpptdata.staticList,
      "onUpdate:staticList": _cache[8] || (_cache[8] = $event => _ctx.IDxgtpptdata.staticList = $event),
      beforeStrList: _ctx.IDxgtpptdata.beforeStrList,
      "onUpdate:beforeStrList": _cache[9] || (_cache[9] = $event => _ctx.IDxgtpptdata.beforeStrList = $event),
      onGetClickBtnType: _ctx.getClickBtnType_gysj,
      onUploadAddRow: _ctx.uploadAddRow
    }, null, 8, ["loading", "tableHeigth", "listHeader", "defaultRow", "tableHeader", "notShowCol", "staticList", "beforeStrList", "onGetClickBtnType", "onUploadAddRow"]), _cache[13] || (_cache[13] = _createElementVNode("div", {
      class: "lc_ttop lc_bzt"
    }, "备注", -1)), _createElementVNode("div", _hoisted_2, [(_openBlock(), _createBlock(_component_lctinymce, {
      id: _ctx.data.id,
      ref: "editor",
      height: _ctx.data.height,
      "cur-value": _ctx.data.remark,
      onInput: _ctx.inputContent,
      key: _ctx.data.key
    }, null, 8, ["id", "height", "cur-value", "onInput"]))]), (_openBlock(), _createBlock(_component_LcWriteLinks, {
      key: _ctx.IDxgtpptdata.isShowLinksDialogIndex,
      isShowLinksDialog: _ctx.IDxgtpptdata.isShowLinksDialog,
      "onUpdate:isShowLinksDialog": _cache[10] || (_cache[10] = $event => _ctx.IDxgtpptdata.isShowLinksDialog = $event),
      onGetDragWriteData: _ctx.getDragWriteData
    }, null, 8, ["isShowLinksDialog", "onGetDragWriteData"]))]),
    _: 1,
    __: [11, 12, 13]
  });
}